import {
  AccountBalance,
  AttachMoney,
  Build,
  CardGiftcard,
  DirectionsBus,
  Flight,
  Gavel,
  Home,
  LabelOutlined,
  LocalHospital,
  LocalMovies,
  People,
  Pets,
  School,
  ShoppingCart,
  Spa,
  Work,
} from "@mui/icons-material";
import React from "react";
export const categoryIconMap = {
  none: <LabelOutlined sx={{ fontSize: 16 }} />,

  "food & groceries": <ShoppingCart sx={{ fontSize: 16 }} />,
  food: <ShoppingCart sx={{ fontSize: 16 }} />,
  groceries: <ShoppingCart sx={{ fontSize: 16 }} />,

  transportation: <DirectionsBus sx={{ fontSize: 16 }} />,

  "home & utilities": <Home sx={{ fontSize: 16 }} />,
  home: <Home sx={{ fontSize: 16 }} />,
  utilities: <Home sx={{ fontSize: 16 }} />,

  "personal & self-care": <Spa sx={{ fontSize: 16 }} />,
  personal: <Spa sx={{ fontSize: 16 }} />,
  "self-care": <Spa sx={{ fontSize: 16 }} />,

  health: <LocalHospital sx={{ fontSize: 16 }} />,

  "entertainment & leisure": <LocalMovies sx={{ fontSize: 16 }} />,
  entertainment: <LocalMovies sx={{ fontSize: 16 }} />,

  education: <School sx={{ fontSize: 16 }} />,

  "finance & banking": <AccountBalance sx={{ fontSize: 16 }} />,
  finance: <AccountBalance sx={{ fontSize: 16 }} />,

  "gifts & donations": <CardGiftcard sx={{ fontSize: 16 }} />,
  gifts: <CardGiftcard sx={{ fontSize: 16 }} />,

  travel: <Flight sx={{ fontSize: 16 }} />,

  "family & children": <People sx={{ fontSize: 16 }} />,
  family: <People sx={{ fontSize: 16 }} />,

  "work & business": <Work sx={{ fontSize: 16 }} />,
  work: <Work sx={{ fontSize: 16 }} />,

  pets: <Pets sx={{ fontSize: 16 }} />,

  "household maintenance": <Build sx={{ fontSize: 16 }} />,
  maintenance: <Build sx={{ fontSize: 16 }} />,

  "taxes & government": <Gavel sx={{ fontSize: 16 }} />,
  taxes: <Gavel sx={{ fontSize: 16 }} />,

  income: <AttachMoney sx={{ fontSize: 16 }} />,
};

export const getIconForCategoryName = (name, color) => {
  if (!name) return <LabelOutlined sx={{ fontSize: 16, color }} />;

  const key = String(name).trim().toLowerCase();

  let icon = categoryIconMap[key];

  if (!icon) {
    const first = key.split(" ")[0];
    icon = categoryIconMap[first];
  }

  if (!icon) {
    for (const k of Object.keys(categoryIconMap)) {
      if (key.includes(k)) {
        icon = categoryIconMap[k];
        break;
      }
    }
  }

  // fallback
  if (!icon) icon = categoryIconMap.none;

  // clone the icon with the color override
  return React.cloneElement(icon, {
    sx: { ...(icon.props.sx || {}), color }, // merge existing sx with new color
  });
};


export const getCategoryDisplay = (name) => {
  const label = name && String(name).trim() ? name : "Uncategorized";
  const icon = getIconForCategoryName(label);

  return { label, icon };
};

